export const bundlesWithVisibleLanguage = []
export const bundlesWithHiddenGlobally = ["accordion_element","button","campaign_teaser","carousel","chart","contact_box","contact_box_generic","container","editorial_title","fact","frame","grid","image","link_box","links","mailxpert","media_gallery","media_gallery_element","node_teaser","numbered_section","person_box","product_teaser","section_title","table","table_markup","table_row","teaser_box","text","video_remote","view","webform"]

export const globalOptionsDefaults = {
  "bkVisibleLanguages": {
    "default": [],
    "type": "checkboxes"
  },
  "bkHiddenGlobally": {
    "default": false,
    "type": "checkbox"
  },
  "marginTop": {
    "default": "normal",
    "type": "radios"
  },
  "teaserColor": {
    "default": "BLUE",
    "type": "radios"
  },
  "anchorId": {
    "default": "",
    "type": "text"
  }
}